import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"; // Ensure React Router is installed

const FamilyTree = () => {
  const chartRef = useRef(null);
  const [nodes, setNodes] = useState([
    { id: 1, name: "Dad", img: "https://cdn-icons-png.flaticon.com/512/236/236831.png" },
    { id: 2, name: "Mom", img: "https://cdn-icons-png.flaticon.com/512/236/236832.png" },
    { id: 3, pid: 1, mid: 2, name: "Emmanuel", img: "https://cdn-icons-png.flaticon.com/512/236/236830.png" },
  ]);
  const [newMember, setNewMember] = useState({ name: "", img: "" });
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (window.OrgChart) {
      new window.OrgChart(chartRef.current, {
        template: "ana",
        nodeBinding: { field_0: "name", img_0: "img" },
        nodes,
        enableDragDrop: true,
      });
    }
  }, [nodes]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        setNewMember((prev) => ({ ...prev, img: e.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const addMember = () => {
    if (!newMember.name.trim()) return;
    setNodes([...nodes, { id: nodes.length + 1, ...newMember }]);
    setNewMember({ name: "", img: "" });
    setSelectedFile(null);
  };

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      
      {/* 🔵 Header */}
      <header className="bg-blue-600 text-white py-4 shadow-md">
        <div className="container mx-auto flex items-center px-6">
          <h1 className="text-2xl font-bold">
            <Link to="/dashboard" className="text-white hover:text-gray-300">lii</Link>
          </h1>
        </div>
      </header>

      {/* 🌳 Family Tree Section */}
      <div className="flex flex-col items-center p-8">
        <h1 className="text-4xl font-bold text-blue-600 mb-6 flex items-center">
          🌳 Family Tree
        </h1>

        {/* ➕ Add Member Form */}
        <div className="bg-white p-6 rounded-xl shadow-md w-96 mb-6">
          <h2 className="text-lg font-semibold mb-4 text-gray-700">Add a Member</h2>

          <input
            type="text"
            value={newMember.name}
            onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
            placeholder="Member Name"
            className="border border-gray-300 p-3 rounded-lg w-full mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
          />

          {/* 📸 Styled File Upload Button */}
          <div className="mb-4 text-center">
            <input
              type="file"
              id="file-upload"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
            <label
              htmlFor="file-upload"
              className="bg-blue-500 text-white py-3 px-6 rounded-lg cursor-pointer hover:bg-blue-600 transition inline-flex items-center justify-center w-full shadow-md"
            >
              📸 Choose a Photo
            </label>
            {selectedFile && <p className="text-sm text-gray-500 mt-2">{selectedFile}</p>}
          </div>

          <button
            onClick={addMember}
            className="w-full py-3 bg-green-500 text-white rounded-lg font-semibold shadow-md hover:bg-green-600 transition"
          >
            ➕ Add Member
          </button>
        </div>

        {/* 🏠 Family Tree Display */}
        <div className="w-full max-w-4xl h-[700px] bg-white shadow-xl rounded-xl relative">
          <div ref={chartRef} className="w-full h-full" />
        </div>
      </div>
    </div>
  );
};

export default FamilyTree;